import { translate } from '@/i18n/i18n'
import { useUiStore } from '@/stores/ui.store'
import type { RedirectBehavior } from '@/ts/types/redirect.types'
import { provide } from 'vue'

export const REDIRECT_BUTTON_KEY = Symbol()

export type RedirectButtonSetupInjection = {
  onClick: (targetUrl: string, redirectBehavior: RedirectBehavior) => void
}

export const useRedirectButtonSetup = () => {
  const { setModal } = useUiStore()

  const onClick = (targetUrl: string, redirectBehavior: RedirectBehavior) => {
    switch (redirectBehavior) {
      case 'target_self':
        window.open(targetUrl, '_self')
        break
      case 'target_blank_with_overlay':
        openModal(targetUrl)
        break
      default:
        window.open(targetUrl, '_blank')
    }
  }

  const openModal = (targetUrl: string) => {
    setModal(
      'RedirectBlankModal',
      {
        footer: {
          closeButton: {
            visible: false
          },
          confirmationButton: {
            visible: true,
            label: translate('checkout.button_text')
          }
        }
      },
      {
        onConfirm: () => {
          window.open(targetUrl, '_blank')
          setModal(null)
        }
      }
    )
  }

  provide<RedirectButtonSetupInjection>(REDIRECT_BUTTON_KEY, { onClick })
}
